import React, { useState } from 'react';
import { Table } from 'react-bootstrap';
import Button from './Button';

const ButtonTable = (props) => {
    const [counter, setCounter] = useState(0);
    const incrementCounter = (incrementValue) => setCounter(counter + incrementValue);
    return (
        <Table align='center' striped bordered hover cellPadding={16}>
            <tbody>
            <tr>
                <td>
                    <Button message="Lone Tree" to="/acknowledge/Lone Tree" />
                </td>
                <td>
                    <Button message="McCoy Cove" to="/acknowledge/McCoy Cove" />
                </td>
            </tr>
            <tr>
                <td>
                    <Button message="Ruby Hill" to="/acknowledge/Ruby Hill" />
                </td>
                <td>
                    <Button message="Granite Creek" to="/acknowledge/Granite Creek" />
                </td>
            </tr>
         </tbody>
        </Table>
    );
}

export default ButtonTable;